var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full md:w-3/4 md:pr-20" }, [
        _c("form", [
          _c("section", [
            _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
              _vm._v("Account information"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c(
                "label",
                {
                  ref: "organization_name",
                  attrs: { for: "organization_name" },
                },
                [
                  _vm._v("\n                            Organization Name "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-sm font-sans-book" }, [
                    _vm._v(
                      "\n                            If you are an individual not associated with an organization or company, please enter your first and last name in this field.\n                            "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.organization_name,
                    expression: "form.organization_name",
                  },
                ],
                attrs: {
                  id: "organization_name",
                  type: "text",
                  name: "organization_name",
                },
                domProps: { value: _vm.form.organization_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "organization_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("organization_name"),
                      expression: "errors.has('organization_name')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("organization_name")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _c("label", { attrs: { for: "organization_url" } }, [
                  _vm._v(
                    "\n                            Organization/Company Website URL\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("url-input", {
                  model: {
                    value: _vm.form.organization_url,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "organization_url", $$v)
                    },
                    expression: "form.organization_url",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "first_name", attrs: { for: "first_name" } }, [
                _vm._v("\n                            First Name "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.first_name,
                    expression: "form.first_name",
                  },
                ],
                attrs: { id: "first_name", type: "text", name: "first_name" },
                domProps: { value: _vm.form.first_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "first_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("first_name"),
                      expression: "errors.has('first_name')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("first_name")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "last_name", attrs: { for: "last_name" } }, [
                _vm._v("\n                            Last Name "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.last_name,
                    expression: "form.last_name",
                  },
                ],
                attrs: { id: "last_name", type: "text", name: "last_name" },
                domProps: { value: _vm.form.last_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "last_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("last_name"),
                      expression: "errors.has('last_name')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("last_name")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "email", attrs: { for: "email" } }, [
                _vm._v("\n                            Account Contact Email "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                ],
                attrs: { id: "email", type: "email", name: "email" },
                domProps: { value: _vm.form.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("email"),
                      expression: "errors.has('email')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("email")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "phone", attrs: { for: "phone" } }, [
                _vm._v(
                  "\n                            Account Contact Phone Number "
                ),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.phone,
                    expression: "form.phone",
                  },
                ],
                attrs: { id: "phone", type: "text", name: "phone" },
                domProps: { value: _vm.form.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "phone", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("phone"),
                      expression: "errors.has('phone')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("phone")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "password", attrs: { for: "password" } }, [
                _vm._v("\n                            Password "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:8|upperCase|number|lowerCase",
                    expression: "'required|min:8|upperCase|number|lowerCase'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password,
                    expression: "form.password",
                  },
                ],
                ref: "passwordInput",
                attrs: { id: "password", type: "password", name: "password" },
                domProps: { value: _vm.form.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "password", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password"),
                      expression: "errors.has('password')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("password")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c(
                "label",
                {
                  ref: "password_confirmation",
                  attrs: { for: "password_confirmation" },
                },
                [
                  _vm._v(
                    "\n                            Password Confirmation "
                  ),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|confirmed:passwordInput",
                    expression: "'required|confirmed:passwordInput'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password_confirmation,
                    expression: "form.password_confirmation",
                  },
                ],
                attrs: {
                  id: "password_confirmation",
                  type: "password",
                  name: "password_confirmation",
                  "data-vv-as": "password",
                },
                domProps: { value: _vm.form.password_confirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form,
                      "password_confirmation",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password_confirmation"),
                      expression: "errors.has('password_confirmation')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("password_confirmation")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
              _vm._v("Information for public festival directory"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "accountType", attrs: { for: "title" } }, [
                _vm._v(
                  "\n                            Do you want to be represented as an individual or as a multi-person organization? "
                ),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-sm font-sans-book mb-12" }, [
                _vm._v(
                  '\n                            If you select "individual," we will use singular pronouns in website copy. For example, "I am here to reimagine..." For multi-person organizations, we say "We are here to reimagine..."\n                        '
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group__radio" }, [
                _c("div", { staticClass: "select-box flex flex-wrap0" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "text-base font-normal w-full md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.accountType,
                            expression: "form.accountType",
                          },
                        ],
                        attrs: {
                          name: "accountType",
                          type: "radio",
                          value: "individual",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.accountType, "individual"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "accountType",
                              "individual"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "radio inline-block mr-2" }),
                      _vm._v(" Individual\n                                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "text-base font-normal w-full md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.accountType,
                            expression: "form.accountType",
                          },
                        ],
                        attrs: {
                          name: "accountType",
                          type: "radio",
                          value: "organization",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.accountType, "organization"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "accountType",
                              "organization"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "radio inline-block mr-2" }),
                      _vm._v(
                        " Multi-person organization\n                                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("accountType"),
                        expression: "errors.has('accountType')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("accountType")))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "story", attrs: { for: "story" } }, [
                _vm._v(
                  "\n                            What’s your organization’s story? "
                ),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                _vm._v(" "),
                _c("div", { staticClass: "text-sm font-sans-book mb-12" }, [
                  _vm._v(
                    "\n                                900 characters maximum. This is your bio and description, which can include your mission statement, types of resources you provide, and/or what inspired you to do this work. Use I/we when you can; stories are better when they are in your personal voice!\n                            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.story,
                    expression: "form.story",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:900",
                    expression: "'required|max:900'",
                  },
                ],
                attrs: { id: "story", name: "story" },
                domProps: { value: _vm.form.story },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "story", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
                [_vm._v("Character count: " + _vm._s(_vm.storyCount))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("story"),
                      expression: "errors.has('story')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("story")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "reimagine", attrs: { for: "reimagine" } }, [
                _vm._v(
                  "\n                            Finish the following: \"What I'm / What we're here to reimagine...\" "
                ),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                _vm._v(" "),
                _c("div", { staticClass: "text-sm font-sans-book mb-12" }, [
                  _vm._v(
                    "\n                                240 characters maximum. What is your inspiring vision, mantra, or change you wish to see in the world? Keep this short, sweet, and unique. No need to repeat the phrase above, just complete it midway through the sentence.\n                            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.reimagine,
                    expression: "form.reimagine",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:240",
                    expression: "'required|max:240'",
                  },
                ],
                ref: "reimagine",
                attrs: { id: "reimagine", name: "reimagine" },
                domProps: { value: _vm.form.reimagine },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "reimagine", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
                [_vm._v("Character count: " + _vm._s(_vm.reimagineCount))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("reimagine"),
                      expression: "errors.has('reimagine')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("reimagine")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "publicPhone" } }, [
                _vm._v(
                  "\n                            Public Phone Number\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.publicPhone,
                    expression: "form.publicPhone",
                  },
                ],
                attrs: { id: "publicPhone", type: "text", name: "publicPhone" },
                domProps: { value: _vm.form.publicPhone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "publicPhone", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "publicEmail" } }, [
                _vm._v(
                  "\n                            Public Email\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.publicEmail,
                    expression: "form.publicEmail",
                  },
                ],
                attrs: { id: "publicEmail", type: "text", name: "publicEmail" },
                domProps: { value: _vm.form.publicEmail },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "publicEmail", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "city" } }, [
                _vm._v(
                  "\n                            City\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.city,
                    expression: "form.city",
                  },
                ],
                attrs: { id: "city", type: "text", name: "city" },
                domProps: { value: _vm.form.city },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "city", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "state" } }, [
                _vm._v(
                  "\n                            State\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.state,
                    expression: "form.state",
                  },
                ],
                attrs: { id: "state", type: "text", name: "state" },
                domProps: { value: _vm.form.state },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "state", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _c("label", { attrs: { for: "facebookUrl" } }, [
                  _vm._v(
                    "\n                            Facebook URL\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("url-input", {
                  model: {
                    value: _vm.form.facebookUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "facebookUrl", $$v)
                    },
                    expression: "form.facebookUrl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _c("label", { attrs: { for: "twitterUrl" } }, [
                  _vm._v(
                    "\n                            Twitter URL\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("url-input", {
                  model: {
                    value: _vm.form.twitterUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "twitterUrl", $$v)
                    },
                    expression: "form.twitterUrl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _c("label", { attrs: { for: "instagramUrl" } }, [
                  _vm._v(
                    "\n                            Instagram URL\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("url-input", {
                  model: {
                    value: _vm.form.instagramUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "instagramUrl", $$v)
                    },
                    expression: "form.instagramUrl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _c("label", { attrs: { for: "linkedinUrl" } }, [
                  _vm._v(
                    "\n                            LinkedIn URL\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("url-input", {
                  model: {
                    value: _vm.form.linkedinUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "linkedinUrl", $$v)
                    },
                    expression: "form.linkedinUrl",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
              _vm._v("Terms & Conditions"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "agreeToTerms", attrs: { for: "password" } }, [
                _vm._v("\n                            Terms & Conditions "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "select-box" }, [
                _c("label", { staticClass: "text-base font-normal" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.agreeToTerms,
                        expression: "agreeToTerms",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { type: "checkbox", name: "agreeToTerms" },
                    domProps: {
                      checked: Array.isArray(_vm.agreeToTerms)
                        ? _vm._i(_vm.agreeToTerms, null) > -1
                        : _vm.agreeToTerms,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.agreeToTerms,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.agreeToTerms = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.agreeToTerms = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.agreeToTerms = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "check inline-block mr-2" }),
                  _vm._v("I agree\n                            "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("agreeToTerms"),
                      expression: "errors.has('agreeToTerms')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("agreeToTerms")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              class: { "opacity-50 cursor-not-allowed": _vm.processing },
              attrs: { disabled: _vm.processing },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.validateRegister.apply(null, arguments)
                },
              },
            },
            [_vm.processing ? [_vm._v("Processing...")] : [_vm._v("Register")]],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-full md:w-1/4 border-t-5 border-black pt-3 mt-10 md:mt-2",
        },
        [
          _c("h2", { staticClass: "text-lg mb-5 font-sans-bold" }, [
            _vm._v("Help with Registration"),
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("support"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "PLEASE NOTE: Your registration for this Collaborator Portal automatically creates your account for our ticketing system through our partner SquadUP. Your login credentials to access SquadUP's mobile app for onsite event registration/check-in will be the same as your portal login."
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-sm font-sans-book" }, [
      _c("span", { staticClass: "font-sans-bold" }, [
        _vm._v(
          "Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number."
        ),
      ]),
      _vm._v(
        " NOTE: There is only one account associated with an event. Therefore, you might need to share your portal login credentials with others who are working on your event (to help input details, for check-in at your event, etc.) Please be sure to set a password you are comfortable sharing, if necessary.\n                            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-12" }, [
      _c("p", [
        _vm._v(
          'By clicking "I agree," I agree that I have reviewed and agree with Reimagine\'s '
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.letsreimagine.org/terms-conditions/",
              target: "_blank",
            },
          },
          [_vm._v("Terms & Conditions")]
        ),
        _vm._v(" and "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.letsreimagine.org/privacy-cookies/",
              target: "_blank",
            },
          },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(
          " and that if I am registering on behalf of an organization, I warrant that I am authorized by the organization to register on its behalf."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://docs.google.com/document/d/1CXgEzIgteW5_VsPhhDAM_VevMcSO6mCwOviWILMD8ug/edit?usp=sharing",
            },
          },
          [_vm._v("Profile and Account Guide")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }